import { render, staticRenderFns } from "./GiftingAddressItem.vue?vue&type=template&id=9f8ae2dc&scoped=true&"
import script from "./GiftingAddressItem.vue?vue&type=script&lang=js&"
export * from "./GiftingAddressItem.vue?vue&type=script&lang=js&"
import style0 from "./GiftingAddressItem.vue?vue&type=style&index=0&id=9f8ae2dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8ae2dc",
  null
  
)

export default component.exports